module.exports = __webpack_public_path__ + "img/fixpel.ef50698b.png";